import { useEffect, useRef, useState } from "react";

// Shared by the Audit/Call/CallConfirmed lead-magnet pages, which all embed
// a Loom video the same way: try the iframe, fall back to a direct link if
// it hasn't loaded within 8s.
const LoomEmbed = ({ url, title }) => {
    const loadedRef = useRef(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        loadedRef.current = false;
        setFailed(false);
        const timer = setTimeout(() => {
            if (!loadedRef.current) setFailed(true);
        }, 8000);
        return () => clearTimeout(timer);
    }, [url]);

    if (failed) {
        return (
            <div className="lead-embed">
                <div className="lead-embed__fallback">
                    <p>The video didn't load.</p>
                    <a href={url} target="_blank" rel="noopener noreferrer">Watch it on Loom instead</a>
                </div>
            </div>
        );
    }

    const src = `${url}${url.includes("?") ? "&" : "?"}hideEmbedTopBar=true&hide_speed=true`;

    return (
        <div className="lead-embed">
            <iframe
                src={src}
                title={title}
                allow="fullscreen"
                className="lead-embed__iframe"
                onLoad={() => { loadedRef.current = true; }}
                onError={() => setFailed(true)}
            />
        </div>
    );
};

export default LoomEmbed;
